import { useState, useEffect } from "react";
import SecondaryNav from "../../../Navbar/SecondaryNav/SecondaryNav";
import SearchBar from "../../../Searchbar/Searchbar";
import "./Fellows.css";
import axios from "axios";
import Navbar from "../../../Navbar/Navbar";
import Footer from "../../../Footer/Footer";

const Fellows = () => {
  const [selectedfellow, setSelectedfellow] = useState('All');
  const [isfellowsDropdownOpen, setfellowsDropdownOpen] = useState(null); 
  const TogglefellowDropdown = (dropdownType) => {
    setfellowsDropdownOpen(isfellowsDropdownOpen === dropdownType ? null : dropdownType);
  };
  const handlefellowFilter = (year) => {
    setSelectedfellow(year);
    // applyFilters(cardsData, selectedLocation, projType); 
    TogglefellowDropdown("proj-type");
  };

  const [FellowData, setFellowData] = useState([]);

  useEffect(() => {
    axios.get('/api/fellows/')
      .then(response => {
        setFellowData(response.data);
      })
      .catch(error => {
        alert("error");
        console.error('Error fetching Fellows data:', error);
      });
  }, []);

  return (
    <>
    <Navbar />
      <SecondaryNav />
      <div className="fellows-page">
        <h2 className="title1">Fellows</h2>
        <div className="lead-search">
          <SearchBar />
        </div> 

        <div id='fellowsdropdown' className='project-dropdown-container proj-type'>
          <button onClick={() => TogglefellowDropdown("proj-type")} className={`dropdown-toggle-btn active-btn ${isfellowsDropdownOpen==="proj-type" ? "active" : ""}`} type='button' value={"All"}>
            <span>{selectedfellow}</span>
          </button>
            <div className={`project-dropdown scroll ${isfellowsDropdownOpen==="proj-type" ? "active" : ""}`}>
              <button className=' inactive-btn ' onClick={() => handlefellowFilter('All')} type='button' value={"All"}>
                <span>All</span>
              </button>
              <button className=' inactive-btn ' onClick={() => handlefellowFilter('2024')} type='button' value={"2024"}>
                <span>2024</span>
              </button>
              <button className=' inactive-btn ' onClick={() => handlefellowFilter('2023')} type='button' value={"2023"}>
                <span>2023</span>
              </button>
              <button className=' inactive-btn ' onClick={() => handlefellowFilter('2022')} type='button' value={"2022"}>
                <span>2022</span>
              </button>
              <button className=' inactive-btn ' onClick={() => handlefellowFilter('2021')} type='button' value={"2021"}>
                <span>2021</span>
              </button>
              <button className=' inactive-btn ' onClick={() => handlefellowFilter('2020')} type='button' value={"2020"}>
                <span>2020</span>
              </button>
            </div>
        </div>
        <div className="card-list">
          {FellowData.map((item, index) => (
            <Card key={index} item={item} />
          ))}
        </div>
        <div className="dummy"></div>
      </div>
    <Footer />
    </>
  );
};

const Card = ({ item }) => {
  const [Mouseon, setMouseState] = useState(false);

  const handleMouseEnter = (event) => {
    const elements = document.getElementsByClassName("image");
    for (const element of elements) {
      element.classList.add("overlay");
    }
    event.target.classList.remove("overlay");
  };

  const handleMouseLeave = (event) => {
    const elements = document.getElementsByClassName("image");
    for (const element of elements) {
      element.classList.remove("overlay");
    }
  };

  const renderSocial = (val) => {
    if (val) {
      if (val.includes("facebook.com")) {
        return "Facebook";
      } else if (val.includes("instagram.com")) {
        return "Instagram";
      } else if (val.includes("github.com")) {
        return "Github";
      } else if (val.includes("gitlab.com")) {
        return "Gitlab";
      } else if (val.includes("twitter.com")) {
        return "X/Twitter";
      } else {
        return "Social Media";
      }
    }
  };


  return (
    <div
      className="card-lead"
      onMouseOver={() => {
        setMouseState(true);
      }}
      onMouseOut={() => {
        setMouseState(false);
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img className="image" src={item.Picture} alt={item.Name} />
      <div className={Mouseon ? "on" : "off"}>
        <h4 className="profile-name">Name: {item.Name}</h4>
        <h4 className="profile-position">Position: {item.Title}</h4>
        <h4 className="profile-year">Year: {item.Year}</h4>
        <p className="profile-text">{item.Info}</p>
        <div className="profile-socials">
          {item.Social_Media_URL_1 && <a href={item.Social_Media_URL_1} target={"_blank"}>
            {renderSocial(item.Social_Media_URL_1)}
          </a>}
        </div>
        <div className="profile-socials">
          {item.Social_Media_URL_2 && <a href={item.Social_Media_URL_2} target={"_blank"}>
            {renderSocial(item.Social_Media_URL_2)}
          </a>}
        </div>
      </div>
    </div>
  );
};


export default Fellows;
